const { createLogger, format, transports, addColors } = require('winston');
const { combine, timestamp, printf, errors } = format;
const fs = require('fs'); 
const { Loggly } = require('winston-loggly-bulk');
const SlackHook = require("winston-slack-webhook-transport");

require('winston-daily-rotate-file');
require('dotenv').config();

// log directory based on environment
let logDir = 'logs';

// Create the log directory if it does not exist
if (!fs.existsSync(logDir)) {
    fs.mkdirSync(logDir);
}

const myFormat = printf((info) => {
    let msg = `${info.timestamp} [${info.level}] : `;
    try {
        if(info.httpEndpoint) {
            let httpStatus = info.httpStatus ? info.httpStatus : 'Incoming';
            let httpMethod = info.httpMethod ? info.httpMethod : '';
            let httpInfo = `[${httpStatus}] ${httpMethod} - ${info.httpEndpoint}`;
            let message = info.message ? `${info.message}` : '';
            let userDetails = info.userId ? `[RETAILER - ${info.userId}]` : '';
            let reqPayload = info.payload ? `\nPayload : ${JSON.stringify(info.payload)}` : '';
            let stackTrace = info.stack ? `\n${info.stack}` : '';

            if(info.parent) { // 'parent' will exist in sequalize errors
                message = info.parent.message;
                stackTrace = info.parent.stack;
            }
            msg += `${httpInfo} ${message} ${userDetails} ${reqPayload} ${stackTrace}\n`
        } else {
            msg += info.message;
        }
    } catch(err) {
        console.log(err);
        msg += info.message;
    }
    return msg;
});

const combinedFormat = combine(
    errors({stack: true}),
    format.json(),
    timestamp({ format: 'DD-MM-YYYY HH:mm:ss.SSSZZ' }),
    myFormat
);

const slackFormat = (info) => {
    try {
        if(!info.timestamp) {
            info.timestamp = Date.now();
        }
        if(!info.httpMethod) {
            info.httpMethod = "";
        }
        if(!info.httpStatus) {
            info.httpStatus = "500";
        }
        if(!info.message) {
            info.message = "Frontend Error";
        }
        if(!info.stack) {
            info.stack = " - ";
        }
        if(!info.payload) {
            info.payload = {};
        }
        const timestamp = Math.floor(new Date(info.timestamp).getTime() / 1000);
    
        let stack = info.stack;
        if(typeof info.message === 'object' && info.message != null && info.message.stack) {
            stack = info.message.stack;
        }
        stack = stack.toString();
        stack = stack.replace(/["']/g, "");
        stack = stack.substring(0, 500);
    
        return {
            text: "Error Report",
            blocks: [
                {
                    "type": "header",
                    "text": {
                        "type": "plain_text",
                        "text": "Error Report :x:",
                        "emoji": true
                    }
                },
                {
                    "type": "divider"
                },
                {
                    "type": "section",
                    "fields": [
                        {
                            "type": "mrkdwn",
                            "text": "*Reported On :* \n<!date^"+timestamp+"^{date_short} {time_secs}|"+info.timestamp+">" 
                        },
                        {
                            "type": "mrkdwn",
                            "text": "*RETAILER :* \n " + (info.userId ? info.userId : "")
                        },
                        {
                            "type": "mrkdwn",
                            "text": `*Method :* \n[${info.httpStatus}] ${info.httpMethod}` 
                        },
                        {
                            "type": "mrkdwn",
                            "text": `*Endpoint : *\n${info.httpEndpoint}` 
                        }
                    ]
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: "*Message :* " + info.message + "\n\n ```" + stack + "```"
                    }
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: "*Payload :* \n```" + JSON.stringify(info.payload, undefined, 4).substring(0, 800) + "```" 
                    }
                },
                {
                    "type": "divider"
                }
            ]
        }
    } catch(error) {
        return { text: error.toString() }
    }
}

const localTransports = [
    new transports.DailyRotateFile({
        
        // combined logs
        level: 'info',
        filename: `${logDir}/info-logs/info.log`,
        datePattern: 'DD-MM-YYYY',
        json: true,
        prettyPrint: true,
        prepend: true,
        eol: '\n\n',
        format: combinedFormat
    }),
    new transports.DailyRotateFile({
        
        // error logs
        level: 'error',
        filename: `${logDir}/error-logs/error.log`,
        datePattern: 'DD-MM-YYYY',
        prettyPrint: true,
        json: true,
        handleExceptions: true,
        eol: '\n\n\n',
        format: combinedFormat
    })
]

let logger;
if (process.env.NODE_ENV === "production") {

    logger = createLogger({
        level: 'info',
        transports: [

            // transport to loggly and local files 
            new Loggly({
                token: process.env.LOGGLY_TOKEN,
                subdomain: process.env.LOGGLY_DOMAIN,
                tags: ["Winston-NodeJS"],
                json: true,
                format: combinedFormat
            }),
            new SlackHook({
                level: "error",
                webhookUrl: process.env.SLACK_WEBHOOK_URL,
                formatter: slackFormat
            }),
            ...localTransports
        ],
        exitOnError: false,
    });

} else {

    logger = createLogger({
        level: 'debug',
        transports: [

            // transport to console and local files
            new transports.Console({
                level: 'debug',
                handleExceptions: true,
                handleRejections: true,
                json: true,
                prettyPrint: true,
                format: combine(
                    combinedFormat,
                    format.colorize({all: true})
                )
            }),
            ...localTransports
        ],
        exitOnError: false,
    });
}

const winstonStream = {
    write: (message) => {
        try {
            let rawData = message.split('|');
            let httpMethod = rawData[0];
            let httpEndpoint = rawData[1];
            let userId = rawData[2] != '-' ? rawData[2] : '';
            let payload = JSON.parse(rawData[3]);

            const metaData = {
                httpMethod,
                httpEndpoint,
                userId,
                payload,
                message: 'Incoming'
            }

            logger.log({ level: "info", ...metaData });
        } catch(err) {
            console.log(err);
            logger.log({ level: "info", message: message });
        }
    },
};

module.exports = {
    logger,
    winstonStream
};